<template>
  <v-row class="border-left--secondarytext border-left--5">
    <v-col cols="auto">
      <v-checkbox
        hide-details
        class="py-0 my-0"
        color="success"
        v-model="completed"
        :disabled="disabled || !canEdit"
      ></v-checkbox>
    </v-col>
    <v-col cols="auto" class="px-0">
      <due-date-chip
        :dueDate="completed ? goalTask.completeDate : goalTask.dueDate"
        v-on:click="canEdit ? $emit('edit', goalTask) : null"
        :completed="completed"
      ></due-date-chip>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="auto" class="pa-1 my-auto">
      <v-menu absolute>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            :disabled="completed || !canEdit"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="$emit('edit', goalTask)">
            <v-list-item-icon>
              <v-icon>edit</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item @click="deleteGoalTask()">
            <v-list-item-icon>
              <v-icon>delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
    <v-col
      cols="12"
      :class="
        'pt-0 secondarytext--text subtitle-2 font-weight-light ' +
          (completed ? 'text-decoration-line-through' : '')
      "
    >
      {{ goalTask.text }}
    </v-col>
  </v-row>
</template>

<script>
import DueDateChip from "@/components/checkin/DueDateChip";
export default {
  name: "GoalTaskLineItem",
  components: { DueDateChip },
  props: {
    goalTask: { type: Object },
    disabled: { type: Boolean, default: false },
    canEdit: { type: Boolean, default: false }
  },
  computed: {
    completed: {
      get() {
        return this.goalTask.completeDate != null;
      },
      set(val) {
        if (val) {
          this.completeTask();
        } else {
          this.reopenTask();
        }
      }
    }
  },
  methods: {
    reopenTask() {
      this.$store
        .dispatch("goal/reopenGoalTask", this.goalTask)
        .then(() => {
          this.$emit("save");
          this.$root.$snackbarSuccess("Sub-goal reopened");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while reopening your sub-goal."
          );
        });
    },
    completeTask() {
      this.$store
        .dispatch("goal/completeGoalTask", this.goalTask)
        .then(() => {
          this.$emit("save");
          this.$root.$snackbarSuccess("Sub-goal completed");
          this.dialog = false;
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while completing your sub-goal."
          );
        });
    },
    async deleteGoalTask() {
      if (
        await this.$root.$confirm(
          "Delete sub-goal",
          "Are you sure you want to delete this sub-goal?",
          { color: "red" }
        )
      ) {
        this.saving = true;
        this.$store
          .dispatch("goal/deleteGoalTask", {
            userId: this.goalTask.userId,
            goalId: this.goalTask.goalId,
            id: this.goalTask.id
          })
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess("Sub-goal deleted");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while deleting a sub-goal."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-list-item__content {
  flex-basis: 50%;
}
</style>
